import {
  ref, Ref,
} from 'vue'
import { debounce, uniqueId } from 'lodash'
import type { DebouncedFunc } from 'lodash'

export interface StatusHook<P> {
  delayExec: DebouncedFunc<() => Promise<P>>
  exec: () => Promise<void | P>
  loading: Ref<boolean>
  error: Ref<string>
}

export default function useStatus<P>(
  factory: () => Promise<P>,
): StatusHook<P> {
  const loading = ref(false)
  let callId = uniqueId('status-')
  const error = ref('')
  const exec = () => {
    loading.value = true
    error.value = ''
    callId = uniqueId('status-')

    const currentId = callId
    return factory()
      .then(prev => {
        if (currentId === callId) {
          loading.value = false
        }
        return prev
      })
      .catch(e => {
        if (currentId === callId) {
          error.value = e.message
          loading.value = false
        }
      })
  }

  const delayExec = debounce(exec, 300, {
    leading: true,
    trailing: true,
  })

  return {
    delayExec,
    exec,
    loading,
    error,
  }
}
